import { CommonModule, Location } from '@angular/common'; 
import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { FooterComponent } from '../../../components/footer-main/footer-main';
import { FooterDesktopComponent } from '../../../components/footer-desktop/footer-desktop';
import { HeaderComponent } from '../../../components/header-main/header-main';
import { HeaderDesktopComponent } from '../../../components/header-desktop/header-desktop';
import { support } from '../../../../environments/support';

@Component({
    imports: [CommonModule, FooterComponent, FooterDesktopComponent, HeaderComponent, HeaderDesktopComponent],
    selector: 'app-support',
    templateUrl: './detail.page.html'
})
export class DetailPage implements OnInit {
  app: any;
  type: string = '';
  id: string = '';
  slug: string = '';
  support: any;
  article: any=[];

  constructor(
    private metaService: Meta,
    private route: ActivatedRoute,
    private titleService: Title,
    private location: Location
  ) { }
  ngOnInit() {
    const cat = this.route.snapshot.paramMap.get('category')?.replace('-', '_');
    this.type = cat || '';
    this.slug = this.route.snapshot.paramMap.get('id') || '';
    if (this.type === 'platform_etiquette') {
      this.support = support.platform_etiquette;
    } else if (this.type == 'registration') {
      this.support = support.registration; 
    } else if (this.type == 'gig_lister') {
      this.support = support.gig_lister; 
    } else if (this.type == 'gig_worker') {
      this.support = support.gig_worker;
    } else if (this.type == 'job_lister') {
      this.support = support.job_lister; 
    } else if (this.type == 'job_hunter') {
      this.support = support.job_hunter;
    } else if (this.type == 'recruiter') {
      this.support = support.recruiter;
    } else if (this.type == 'promote') {
      this.support = support.promote;
    } else if (this.type == 'volunteer') {
      this.support = support.volunteer; 
    } else if (this.type == 'volunteer_request') {
      this.support = support.volunteer_request;
    } else if (this.type == 'technology') {
      this.support = support.technology;
    } else if (this.type == 'money') {
      this.support = support.money;
    } else {
      this.type = 'platform_etiquette';
      this.support = support.platform_etiquette;
    }
    this.getArticle(this.type,this.slug);
  }

  async getArticle(type: string, slug: string) {
    this.article = this.support.find((o: { seo: { canonicalUrl: string; }; }) => o.seo.canonicalUrl === this.slug);
    if (this.article.seo.metaTitle) {
      this.titleService.setTitle(this.article.seo.metaTitle);
    } else {
      this.titleService.setTitle(this.article.title);        
    }
    
    if (this.article.seo.metaDescription) {
      this.metaService.updateTag(
        { name: 'description', property: 'og:description', content: this.article.seo.metaDescription }
      )
    } else {
      this.metaService.updateTag(
        { name: 'description', property: 'og:description', content: this.article.summary }
      )
    }
  }

  goBack() {
    this.location.back(); // Navigate back in the browser history
  }
}
